import { PencomGenericBanner } from "@/components/banners/PencomBanner";
import { PrimaryButton } from "@/components/buttons/PrimaryButton";
import { PencomBackButton } from "@/components/layout/PencomBackButton";
import PencomTextField from "@/components/input/PencomTextField";
import { useForm } from "@tanstack/react-form";
import { PencomRoutes } from "@/router/PencomRoutes";
import { useNavigate } from "react-router-dom";

export const EmployeeVerificationPage = () => {
    const navigate = useNavigate();

    const form = useForm({
        defaultValues: {
            otp: '',
        },
        onSubmit: async ({ value }) => {
            console.log('Verifying code:', value.otp);
            navigate(PencomRoutes.EMPLOYER_REP_DETAILS);
        },
    });

    const handleSubmit = () => {
        form.handleSubmit();
    }
    return (
        <div className="w-full flex flex-col min-h-screen justify-center">
            <PencomBackButton title="Back" />
            <div className="w-full flex flex-col  max-w-[460px] mx-auto mt-[80px]">



                <div className="flex flex-col gap-y-2 items-center justify-center">
                    <h2 className="text-3xl font-bold font-clash-display text-gray-900">
                        We've sent you a code
                    </h2>
                    <span className="text-medium-dark-grey text-sm font-regular font-clash-display">
                        To continue, enter the 6 digit code sent to <span className='font-semibold text-sm text-medium-dark-grey font-clash-display'>sample@gmail.com & 0904*******35</span>
                    </span>
                </div>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        void form.handleSubmit();
                    }}
                    className='flex flex-col mt-8 gap-y-6'
                >
                    <form.Field
                        name="otp"
                        validators={{
                            onChange: ({ value }) => {
                                if (!value) return 'OTP is required.';
                                if (value.length !== 6) return 'OTP must be 6 digits.';
                                return undefined;
                            },
                        }}
                        children={(field) => (
                            <PencomTextField
                                id="verification-code"
                                label="OTP"
                                type="otp"
                                value={field.state.value}
                                onChange={(value) => field.handleChange(value.target.value)}
                                otpLength={6}
                                error={!!field.state.meta.errors.length}
                                helperText={field.state.meta.errors.join(", ")}
                            />
                        )}
                    />

                    <PrimaryButton
                        className='mt-10'
                        title='Verify'
                        onClick={handleSubmit}
                    />
                </form>

                <PencomGenericBanner className='mt-6' title='Didn’t get code?'>
                    <div className='flex flex-col items-start justify-center gap-y-4'>
                        <p className='font-clash-display text-medium-grey text-sm font-regular'>Please check your SPAM or JUNK folder if you don’t see it. If it’s still not there, click the button below and a new one will be sent to you.</p>
                        <div className='flex flex-row px-2 py-2 cursor-pointer hover:scale-105 transition-all duration-300 rounded-[3px] bg-lightest-green items-center justify-center '>
                            <p className='font-clash-display text-primary-button text-xs font-semibold'>Resend email</p>
                        </div>
                    </div>
                </PencomGenericBanner>
            </div>
        </div>

    );
};

export const AuthorizedContactVerificationPage = () => {
    const navigate = useNavigate();

    const form = useForm({
        defaultValues: {
            otp: '',
        },
        onSubmit: async ({ value }) => {
            console.log('Verifying code:', value.otp);
            navigate(PencomRoutes.ONBOARDING_COMPLETION);
        },
    });

    const handleSubmit = () => {
        form.handleSubmit();
    }
    return (
        <div className="w-full flex flex-col min-h-screen justify-center">
            <PencomBackButton title="Back" />
            <div className="w-full flex flex-col  max-w-[460px] mx-auto mt-[80px]">



                <div className="flex flex-col gap-y-2 items-center justify-center">
                    <h2 className="text-3xl font-bold font-clash-display text-gray-900">
                        We've sent you a code
                    </h2>
                    <span className="text-medium-dark-grey text-sm font-regular font-clash-display">
                        To continue, enter the 6 digit code sent to <span className='font-semibold text-sm text-medium-dark-grey font-clash-display'>sample@gmail.com & 0904*******35</span>
                    </span>
                </div>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        void form.handleSubmit();
                    }}
                    className='flex flex-col mt-8 gap-y-6'
                >
                    <form.Field
                        name="otp"
                        validators={{
                            onChange: ({ value }) => {
                                if (!value) return 'OTP is required.';
                                if (value.length !== 6) return 'OTP must be 6 digits.';
                                return undefined;
                            },
                        }}
                        children={(field) => (
                            <PencomTextField
                                id="verification-code"
                                label="OTP"
                                type="otp"
                                value={field.state.value}
                                onChange={(value) => field.handleChange(value.target.value)}
                                otpLength={6}
                                error={!!field.state.meta.errors.length}
                                helperText={field.state.meta.errors.join(", ")}
                            />
                        )}
                    />

                    <PrimaryButton
                        className='mt-10'
                        title='Verify'
                        onClick={handleSubmit}
                    />
                </form>

                <PencomGenericBanner className='mt-6' title='Didn’t get code?'>
                    <div className='flex flex-col items-start justify-center gap-y-4'>
                        <p className='font-clash-display text-medium-grey text-sm font-regular'>Please check your SPAM or JUNK folder if you don’t see it. If it’s still not there, click the button below and a new one will be sent to you.</p>
                        <div className='flex flex-row px-2 py-2 cursor-pointer hover:scale-105 transition-all duration-300 rounded-[3px] bg-lightest-green items-center justify-center '>
                            <p className='font-clash-display text-primary-button text-xs font-semibold'>Resend email</p>
                        </div>
                    </div>
                </PencomGenericBanner>
            </div>
        </div>

    );
};